import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";

import { Enrichments } from "@/enum/enrichments.enum";

import { LiProfileEntryType } from "@/enum/liprofile.enum";

import { ApolloOrgSchema } from "../../Apollo/schema/apolloOrg";

import { ApolloPeopleResponseSchema } from "../../Apollo/schema/get-apollos";

export const LiProfileEntryResultsSchema = z.object({
	id: z.number(),
	liProfileEntryId: z.number(),
	type: z.nativeEnum(LiProfileEntryType),
	content: z.string().nullable(),
	contentUrl: z.string().nullable(),
	contentResponse: z.string().nullable(),
	contentResponseUrl: z.string().nullable(),
	name: z.string().nullable(),
	firstName: z.string().nullable(),
	lastName: z.string().nullable(),
	linkedinUrl: z.string().nullable(),
	companyLocation: z.string().nullable(),
	companyCity: z.string().nullable(),
	companyState: z.string().nullable(),
	companyCountry: z.string().nullable(),
	companyName: z.string().nullable(),
	cleanedCompanyName: z.string().nullable(),
	companyDomain: z.string().nullable(),
	companyLinkedinUrl: z.string().nullable(),
	title: z.string().nullable(),
	headline: z.string().nullable(),
	location: z.string().nullable(),
	city: z.string().nullable(),
	state: z.string().nullable(),
	country: z.string().nullable(),
	status: z.nativeEnum(Enrichments),
	prospect: ApolloPeopleResponseSchema.optional(),
	organization: ApolloOrgSchema.optional(),
});

export const LiProfileEntryResultsResponseSchema = z.object({
	data: z.array(LiProfileEntryResultsSchema),
	meta: MetaDataSchema,
});

export type LiProfileEntryResults = z.infer<typeof LiProfileEntryResultsSchema>;

export type LiProfileEntryResultsResponse = z.infer<typeof LiProfileEntryResultsResponseSchema>;
